import { Field, useFormik, FormikProvider } from "formik";
import React, { useEffect, useState } from "react";
import {
  Col,
  OverlayTrigger,
  Row,
  Tooltip,
  Button,
  Form,
  Modal,
} from "react-bootstrap";
import CustomInput from "../../../CustomControls/CustomInput";
import CustomSelect from "../../../CustomControls/CustomSelect";
import { useFormikContext } from "formik";
import {
  POST_GetCategoryDropDownListByCategoryType,
  POST_GetTestRateByUnitID,
} from "../../../helpers/url_helper";
import { post } from "../../../helpers/api_helper";
import * as Yup from "yup";
import { Spin } from "antd";

const CommonMaterialInformation = () => {
  const { values, setFieldValue } = useFormikContext();
  const [isLoading, setIsLoading] = useState(false);
  const [calcGross, setCalcGross] = useState(false);
  const [calcAdditional, setCalcAdditional] = useState(false);
  const [rateTypeName, setRateTypeName] = useState("");

  const [prformaInvID, setPrformaInvoiceID] = useState("");
  const [allDiscountApply, setallDiscountApply] = useState(false);

  const AuthUser = JSON.parse(localStorage.getItem("userDetails"));

  useEffect(() => {
    getUnitDDL();
  }, []);

  // useEffect(() => {
  //   setCalcGross(true);
  // }, [values.ListOfInwardMaterialsDetails]);
  useEffect(() => {
    if (values.calcGross == true) {
      setCalcGross(true);
      setFieldValue("calcGross", false);
    }
  }, [values.calcGross]);

  // useEffect(() => {
  //   calculateTaxAndNetAmount(values?.TotalGrossAmount ?? 0);
  // }, [values.ListOfGSTPlans]);
  useEffect(() => {
    if (values.calcTaxAndNet == true) {
      calculateTaxAndNetAmount(values?.TotalGrossAmount ?? 0);
      setFieldValue("calcTaxAndNet", false);
    }
  }, [values.calcTaxAndNet]);

  const getUnitDDL = () => {
    post(POST_GetCategoryDropDownListByCategoryType, {
      CompanyIDEncrypted: AuthUser?.CompanyIDEncrypt,
      CategoryType: 8, // Unit
      ParentCategoryID: 0,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setFieldValue(
            "unitOptions",
            response?.List?.map((item) => ({
              label: item.CategoryName,
              value: item.CategoryID,
            })),
          );
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const calculateItemAmount = async (
    itemFieldNameNode,
    qty,
    rate,
    discount,
    prformaInvoiceID,
    performaInvoiceGrossAmount,
  ) => {
    //
    let itemQty = qty ? parseInt(qty) : 0;
    let itemRate = rate ? parseFloat(rate) : 0;
    let itemDiscountPercentage = discount ? parseFloat(discount) : 0;
    let itemGrossAmount = 0;
    let itemDiscountAmount = 0;
    let itemNetAmount = 0;

    if (itemQty > 0 && itemRate > 0) {
      itemGrossAmount = itemQty * itemRate;
      if (itemDiscountPercentage > 0) {
        itemDiscountAmount = (itemGrossAmount * itemDiscountPercentage) / 100;
      }
      itemNetAmount = itemGrossAmount - itemDiscountAmount;
    }

    setFieldValue(
      `${itemFieldNameNode}.GrossAmount`,
      itemGrossAmount.toFixed(2),
    );
    setFieldValue(
      `${itemFieldNameNode}.DiscountAmount`,
      itemDiscountAmount.toFixed(2),
    );
    setFieldValue(`${itemFieldNameNode}.NetAmount`, itemNetAmount.toFixed(2));

    //
    setPrformaInvoiceID(prformaInvoiceID);
    setCalcGross(true);
    //
  };

  const calculateExpenseAmount = (
    itemFieldNameNode,
    calcType,
    qty,
    rate,
    discount,
    performaInvoiceIDEncrypted,
  ) => {
    let itemQty = qty ? parseInt(qty) : 0;
    let itemRate = rate ? parseFloat(rate) : 0;
    let itemDiscountPercentage = discount ? parseFloat(discount) : 0;
    let itemGrossAmount = 0;
    let itemDiscountAmount = 0;
    let itemNetAmount = 0;
    let totalPerformaInvoiceGrossAmount = 0;

    //console.log("performaInvoiceIDEncrypted", performaInvoiceIDEncrypted);

    if (performaInvoiceIDEncrypted != "") {
      //
      if (values?.FormID == 52 || values?.FormID == 63) {
        Promise.all(
          values?.ListOfInwardMaterialsDetails?.map(
            (tc) => (
              Promise.all(
                tc?.ListOfTests?.map((test) => {
                  if (
                    tc?.IsSelected === true &&
                    test?.PerformaInvoiceIDEncrypted ===
                      performaInvoiceIDEncrypted
                  ) {
                    totalPerformaInvoiceGrossAmount =
                      totalPerformaInvoiceGrossAmount +
                      parseFloat(test?.NetAmount ? test?.NetAmount : 0);
                  }
                }),
              ),
              Promise.all(
                tc?.ListOfMachining?.map((m) => {
                  if (tc?.IsSelected === true) {
                    if (
                      m?.PerformaInvoiceIDEncrypted ===
                      performaInvoiceIDEncrypted
                    ) {
                      totalPerformaInvoiceGrossAmount += parseFloat(
                        m?.NetAmount || 0,
                      );
                    }
                  }
                }),
              )
            ),
          ),
        );

        //console.log("itemDiscountPercentage", itemDiscountPercentage);

        if (itemQty > 0 && itemRate > 0) {
          if (calcType == 2) {
            itemGrossAmount =
              itemQty * ((totalPerformaInvoiceGrossAmount * itemRate) / 100);
          } else {
            itemGrossAmount = itemQty * itemRate;
          }
          if (itemDiscountPercentage > 0) {
            itemDiscountAmount =
              (itemGrossAmount * itemDiscountPercentage) / 100;
          }
          itemNetAmount = itemGrossAmount - itemDiscountAmount;
        }
        //
        setFieldValue(
          `${itemFieldNameNode}.GrossAmount`,
          itemGrossAmount.toFixed(2),
        );
        setFieldValue(
          `${itemFieldNameNode}.DiscountAmount`,
          itemDiscountAmount.toFixed(2),
        );
        setFieldValue(
          `${itemFieldNameNode}.NetAmount`,
          itemNetAmount.toFixed(2),
        );
        setCalcAdditional(true);
      } else {
        //
        //console.log("values?.ItemNetAmount", values?.ItemNetAmount);
        if (itemQty > 0 && itemRate > 0) {
          if (calcType == 2) {
            itemGrossAmount =
              itemQty * ((values?.ItemNetAmount * itemRate) / 100);
          } else {
            itemGrossAmount = itemQty * itemRate;
          }
          if (itemDiscountPercentage > 0) {
            itemDiscountAmount =
              (itemGrossAmount * itemDiscountPercentage) / 100;
          }
          itemNetAmount = itemGrossAmount - itemDiscountAmount;
        }

        //
        setFieldValue(
          `${itemFieldNameNode}.GrossAmount`,
          itemGrossAmount.toFixed(2),
        );
        setFieldValue(
          `${itemFieldNameNode}.DiscountAmount`,
          itemDiscountAmount.toFixed(2),
        );
        setFieldValue(
          `${itemFieldNameNode}.NetAmount`,
          itemNetAmount.toFixed(2),
        );
        setCalcAdditional(true);
      }
      //
    } else {
      //
      //console.log("values?.ItemNetAmount", values?.ItemNetAmount);
      if (itemQty > 0 && itemRate > 0) {
        if (calcType == 2) {
          itemGrossAmount =
            itemQty * ((values?.ItemNetAmount * itemRate) / 100);
        } else {
          itemGrossAmount = itemQty * itemRate;
        }
        if (itemDiscountPercentage > 0) {
          itemDiscountAmount = (itemGrossAmount * itemDiscountPercentage) / 100;
        }
        itemNetAmount = itemGrossAmount - itemDiscountAmount;
      }
      //
      setFieldValue(
        `${itemFieldNameNode}.GrossAmount`,
        itemGrossAmount.toFixed(2),
      );
      setFieldValue(
        `${itemFieldNameNode}.DiscountAmount`,
        itemDiscountAmount.toFixed(2),
      );
      setFieldValue(`${itemFieldNameNode}.NetAmount`, itemNetAmount.toFixed(2));
      setCalcAdditional(true);
    }
  };

  useEffect(() => {
    // console.log("calcGross", calcGross);
    if (calcGross == true) {
      calculateGrossAmount();
      setCalcGross(false);
    }
  }, [calcGross]);

  useEffect(() => {
    if (calcAdditional == true) {
      calculateAdditionalAmount();
      setCalcAdditional(false);
    }
  }, [calcAdditional]);

  const calculateGrossAmount = async () => {
    setIsLoading(true);
    let itemGrossAmount = 0;
    let itemTotalDiscountAmount = 0;
    let itemNetAmount = 0;

    Promise.all(
      values?.ListOfInwardMaterialsDetails?.map(
        (tc) => (
          Promise.all(
            tc?.ListOfTests?.map((test) => {
              if (tc.IsSelected == true) {
                itemGrossAmount =
                  itemGrossAmount +
                  parseFloat(test?.GrossAmount ? test?.GrossAmount : 0);
                itemTotalDiscountAmount =
                  itemTotalDiscountAmount +
                  parseFloat(test?.DiscountAmount ? test?.DiscountAmount : 0);
                itemNetAmount =
                  itemNetAmount +
                  parseFloat(test?.NetAmount ? test?.NetAmount : 0);
              }
            }),
          ),
          Promise.all(
            tc?.ListOfMachining?.map((m) => {
              if (tc.IsSelected == true) {
                itemGrossAmount =
                  itemGrossAmount +
                  parseFloat(m?.GrossAmount ? m?.GrossAmount : 0);
                itemTotalDiscountAmount =
                  itemTotalDiscountAmount +
                  parseFloat(m?.DiscountAmount ? m?.DiscountAmount : 0);
                itemNetAmount =
                  itemNetAmount + parseFloat(m?.NetAmount ? m?.NetAmount : 0);
              }
            }),
          )
        ),
      ),
    );

    setFieldValue("GrossAmount", itemGrossAmount.toFixed(2));
    setFieldValue(
      "ItemTotalDiscountAmount",
      itemTotalDiscountAmount.toFixed(2),
    );

    setFieldValue(
      "DiscountAmount",
      itemTotalDiscountAmount + parseFloat(values?.ExpenseTotalDiscountAmount),
    );

    setFieldValue("ItemNetAmount", itemNetAmount.toFixed(2));
    calculatePercentageTypeExpenseAmountOnGrossAmountChange(itemNetAmount);
    setIsLoading(false);
    //
  };

  const calculatePercentageTypeExpenseAmountOnGrossAmountChange = async (
    grossAmount,
  ) => {
    //---
    if (values?.FormID == 52 || values?.FormID == 63) {
      if (
        values?.ListOfExpense?.filter(
          (x) => x.IsSelected == true && x.CalcType == 2,
        )?.length > 0
      ) {
        //--------

        Promise.all(
          values?.ListOfExpense?.map((e, eIndex) => {
            if (e?.IsSelected == true && e?.CalcType == 2) {
              let itemQty = e?.Qty ? parseInt(e?.Qty) : 0;
              let itemRate = e?.ExpenseRate ? parseFloat(e?.ExpenseRate) : 0;
              let itemDiscountPercentage = e?.DiscountPercentage
                ? parseFloat(e?.DiscountPercentage)
                : 0;
              let itemGrossAmount = 0;
              let itemDiscountAmount = 0;
              let itemNetAmount = 0;
              let totalPerformaInvoiceGrossAmount = 0;

              if (allDiscountApply === true) {
                //console.log("11", allDiscountApply);
                Promise.all(
                  values?.ListOfInwardMaterialsDetails?.map(
                    (tc) => (
                      Promise.all(
                        tc?.ListOfTests?.map((test) => {
                          if (tc?.IsSelected === true) {
                            if (e?.PerformaInvoiceIDEncrypted) {
                              if (
                                test?.PerformaInvoiceIDEncrypted ===
                                e?.PerformaInvoiceIDEncrypted
                              ) {
                                totalPerformaInvoiceGrossAmount += parseFloat(
                                  test?.NetAmount || 0,
                                );
                              }
                            }
                          }
                        }),
                      ),
                      Promise.all(
                        tc?.ListOfMachining?.map((m) => {
                          if (tc?.IsSelected === true) {
                            if (e?.PerformaInvoiceIDEncrypted) {
                              if (
                                m?.PerformaInvoiceIDEncrypted ===
                                e?.PerformaInvoiceIDEncrypted
                              ) {
                                totalPerformaInvoiceGrossAmount += parseFloat(
                                  m?.NetAmount || 0,
                                );
                              }
                            }
                          }
                        }),
                      )
                    ),
                  ),
                );
              } else {
                //console.log("22", allDiscountApply);

                if (prformaInvID) {
                  //console.log("prformaInvID-1", prformaInvID);
                  Promise.all(
                    values?.ListOfInwardMaterialsDetails?.map(
                      (tc) => (
                        Promise.all(
                          tc?.ListOfTests?.map((test) => {
                            if (
                              tc?.IsSelected === true &&
                              test?.PerformaInvoiceIDEncrypted === prformaInvID
                            ) {
                              totalPerformaInvoiceGrossAmount += parseFloat(
                                test?.NetAmount || 0,
                              );
                            }
                          }),
                        ),
                        Promise.all(
                          tc?.ListOfMachining?.map((m) => {
                            if (
                              tc?.IsSelected === true &&
                              m?.PerformaInvoiceIDEncrypted === prformaInvID
                            ) {
                              totalPerformaInvoiceGrossAmount += parseFloat(
                                m?.NetAmount || 0,
                              );
                            }
                          }),
                        )
                      ),
                    ),
                  );
                } else {
                  Promise.all(
                    values?.ListOfInwardMaterialsDetails?.map((tc) =>
                      Promise.all(
                        tc?.ListOfTests?.map((test) => {
                          if (tc?.IsSelected === true) {
                            if (e?.PerformaInvoiceIDEncrypted) {
                              if (
                                test?.PerformaInvoiceIDEncrypted ===
                                e?.PerformaInvoiceIDEncrypted
                              ) {
                                totalPerformaInvoiceGrossAmount += parseFloat(
                                  test?.NetAmount || 0,
                                );
                              }
                            }
                            // else {
                            //   totalPerformaInvoiceGrossAmount =
                            //     itemQty *
                            //     ((parseFloat(grossAmount) * itemRate) / 100);
                            // }
                          }
                        }),
                      ),
                    ),
                  );
                }
              }

              if (itemQty > 0 && itemRate > 0) {
                if (e?.CalcType == 2) {
                  if (e?.PerformaInvoiceIDEncrypted) {
                    itemGrossAmount =
                      itemQty *
                      ((parseFloat(totalPerformaInvoiceGrossAmount) *
                        itemRate) /
                        100);
                  } else {
                    if (parseFloat(totalPerformaInvoiceGrossAmount) > 0) {
                      itemGrossAmount =
                        itemQty *
                        ((parseFloat(totalPerformaInvoiceGrossAmount) *
                          itemRate) /
                          100);
                    } else {
                      itemGrossAmount =
                        itemQty * ((parseFloat(grossAmount) * itemRate) / 100);
                    }
                  }
                } else {
                  itemGrossAmount = itemQty * itemRate;
                }

                if (itemDiscountPercentage > 0) {
                  itemDiscountAmount =
                    (itemGrossAmount * itemDiscountPercentage) / 100;
                }

                itemNetAmount = itemGrossAmount - itemDiscountAmount;
              }

              //
              if (e?.PerformaInvoiceIDEncrypted === prformaInvID) {
                //console.log("EE-1");
                setFieldValue(
                  `ListOfExpense[${eIndex}].GrossAmount`,
                  itemGrossAmount.toFixed(2),
                );
                setFieldValue(
                  `ListOfExpense[${eIndex}].DiscountAmount`,
                  itemDiscountAmount.toFixed(2),
                );
                setFieldValue(
                  `ListOfExpense[${eIndex}].NetAmount`,
                  itemNetAmount.toFixed(2),
                );
              } else if (allDiscountApply === true) {
                //console.log("EE-2");
                setFieldValue(
                  `ListOfExpense[${eIndex}].GrossAmount`,
                  itemGrossAmount.toFixed(2),
                );
                setFieldValue(
                  `ListOfExpense[${eIndex}].DiscountAmount`,
                  itemDiscountAmount.toFixed(2),
                );
                setFieldValue(
                  `ListOfExpense[${eIndex}].NetAmount`,
                  itemNetAmount.toFixed(2),
                );
              }
              if (e?.PerformaInvoiceIDEncrypted === "") {
                //console.log("EE-3");
                setFieldValue(
                  `ListOfExpense[${eIndex}].GrossAmount`,
                  itemGrossAmount.toFixed(2),
                );
                setFieldValue(
                  `ListOfExpense[${eIndex}].DiscountAmount`,
                  itemDiscountAmount.toFixed(2),
                );
                setFieldValue(
                  `ListOfExpense[${eIndex}].NetAmount`,
                  itemNetAmount.toFixed(2),
                );
              }
            }
          }),
        );

        setCalcAdditional(true);
      } else {
        // calculateTotalGrossAmount(grossAmount, values?.AdditionalAmount);
        setCalcAdditional(true);
      }
    } else {
      if (
        values?.ListOfExpense?.filter(
          (x) => x.IsSelected == true && x.CalcType == 2,
        )?.length > 0
      ) {
        Promise.all(
          values?.ListOfExpense?.map((e, eIndex) => {
            if (e?.IsSelected == true && e?.CalcType == 2) {
              let itemQty = e?.Qty ? parseInt(e?.Qty) : 0;
              let itemRate = e?.ExpenseRate ? parseFloat(e?.ExpenseRate) : 0;
              let itemDiscountPercentage = e?.DiscountPercentage
                ? parseFloat(e?.DiscountPercentage)
                : 0;
              let itemGrossAmount = 0;
              let itemDiscountAmount = 0;
              let itemNetAmount = 0;
              if (itemQty > 0 && itemRate > 0) {
                if (e?.CalcType == 2) {
                  itemGrossAmount =
                    itemQty * ((parseFloat(grossAmount) * itemRate) / 100);
                } else {
                  itemGrossAmount = itemQty * itemRate;
                }
                if (itemDiscountPercentage > 0) {
                  itemDiscountAmount =
                    (itemGrossAmount * itemDiscountPercentage) / 100;
                }
                itemNetAmount = itemGrossAmount - itemDiscountAmount;
              }
              setFieldValue(
                `ListOfExpense[${eIndex}].GrossAmount`,
                itemGrossAmount.toFixed(2),
              );
              setFieldValue(
                `ListOfExpense[${eIndex}].DiscountAmount`,
                itemDiscountAmount.toFixed(2),
              );
              setFieldValue(
                `ListOfExpense[${eIndex}].NetAmount`,
                itemNetAmount.toFixed(2),
              );
            }
          }),
        );
        setCalcAdditional(true);
      } else {
        // calculateTotalGrossAmount(grossAmount, values?.AdditionalAmount);
        setCalcAdditional(true);
      }
    }
  };

  const calculateAdditionalAmount = () => {
    let additionalAmount = 0;
    let additionalTotalDiscountAmount = 0;
    let additionalNetAmount = 0;
    Promise.all(
      values?.ListOfExpense?.filter((x) => x.IsSelected == true)?.map((e) => {
        additionalAmount =
          additionalAmount + parseFloat(e?.GrossAmount ? e?.GrossAmount : 0);
        additionalTotalDiscountAmount =
          additionalTotalDiscountAmount +
          parseFloat(e?.DiscountAmount ? e?.DiscountAmount : 0);
        additionalNetAmount =
          additionalNetAmount + parseFloat(e?.NetAmount ? e?.NetAmount : 0);
      }),
    );
    setFieldValue("AdditionalAmount", additionalAmount.toFixed(2));
    setFieldValue(
      "ExpenseTotalDiscountAmount",
      additionalTotalDiscountAmount.toFixed(2),
    );
    setFieldValue(
      "DiscountAmount",
      parseFloat(values?.ItemTotalDiscountAmount) +
        additionalTotalDiscountAmount,
    );
    setFieldValue("ExpenseNetAmount", additionalNetAmount.toFixed(2));

    calculateTotalGrossAmount(values?.ItemNetAmount, additionalNetAmount);
  };

  const calculateTotalGrossAmount = (itemNetAmount, additionalNetAmount) => {
    let totalGrossAmount =
      parseFloat(itemNetAmount) + parseFloat(additionalNetAmount);
    setFieldValue("TotalGrossAmount", totalGrossAmount.toFixed(2));

    calculateTaxAndNetAmount(totalGrossAmount);
  };

  const calculateTaxAndNetAmount = (totalGrossAmount) => {
    let netAmount = parseFloat(totalGrossAmount);
    let totalGSTAmount = 0;
    Promise.all(
      values?.ListOfGSTPlans?.map((gst, gstIndex) => {
        let gstAmount = 0;
        if (parseFloat(gst?.GSTPercentage) > 0 && totalGrossAmount > 0) {
          gstAmount =
            (parseFloat(totalGrossAmount) * parseFloat(gst?.GSTPercentage)) /
            100;
          totalGSTAmount = totalGSTAmount + gstAmount;
        }
        setFieldValue(
          `ListOfGSTPlans[${gstIndex}].GSTAmount`,
          gstAmount.toFixed(2),
        );
        setFieldValue(
          `ListOfGSTPlans[${gstIndex}].TaxableAmount`,
          parseFloat(totalGrossAmount).toFixed(2),
        );
      }),
    );
    // netAmount = netAmount + totalGSTAmount;
    netAmount = netAmount + parseFloat(totalGSTAmount.toFixed(2));
    setFieldValue("GSTAmount", totalGSTAmount.toFixed(2));
    //setFieldValue("NetAmount", netAmount.toFixed(2));
    let roundingAmount = 0,
      netAmountAfterRounding = 0;
    netAmountAfterRounding = Math.round(netAmount);
    roundingAmount = netAmountAfterRounding - netAmount;
    setFieldValue("RoundingOff", roundingAmount.toFixed(2));
    setFieldValue("NetAmount", netAmountAfterRounding.toFixed(2));
  };

  const handleChangeIsSelectedTC = (checked, index) => {
    setFieldValue(`ListOfInwardMaterialsDetails[${index}].IsSelected`, checked);

    Promise.all(
      values?.ListOfInwardMaterialsDetails[index]?.ListOfTests?.map(
        (test, testIndex) => {
          setTimeout(() => {
            calculateItemAmount(
              `ListOfInwardMaterialsDetails[${index}].ListOfTests[${testIndex}]`,
              checked == true ? test?.Qty : 0,
              test?.Rate,
              test?.DiscountPercentage,
              test?.PerformaInvoiceIDEncrypted
                ? test?.PerformaInvoiceIDEncrypted
                : "",
              test?.PerformaInvoiceGrossAmount
                ? test?.PerformaInvoiceGrossAmount
                : 0,
            );
          }, 300);
        },
      ),
    );

    Promise.all(
      values?.ListOfInwardMaterialsDetails[index]?.ListOfMachining?.map(
        (m, mIndex) => {
          setTimeout(() => {
            calculateItemAmount(
              `ListOfInwardMaterialsDetails[${index}].ListOfMachining[${mIndex}]`,
              checked == true ? m?.Qty : 0,
              m?.Rate,
              m?.DiscountPercentage,
              m?.PerformaInvoiceIDEncrypted
                ? m?.PerformaInvoiceIDEncrypted
                : "",
              0,
            );
          }, 300);
        },
      ),
    );
  };

  const applyDiscountPercentageToAll = (discountPercentage) => {
    setIsLoading(true);
    let applyAllDiscountPercentage = discountPercentage
      ? discountPercentage
      : 0;

    Promise.all(
      values?.ListOfInwardMaterialsDetails?.map(
        (tc, tcIndex) => (
          Promise.all(
            tc?.ListOfTests?.map((test, testIndex) => {
              if (tc.IsSelected == true) {
                setallDiscountApply(true);

                setFieldValue(
                  `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].DiscountPercentage`,
                  applyAllDiscountPercentage,
                );

                calculateItemAmount(
                  `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}]`,
                  test?.Qty,
                  test?.Rate,
                  applyAllDiscountPercentage,
                  test?.PerformaInvoiceIDEncrypted
                    ? test?.PerformaInvoiceIDEncrypted
                    : "",
                  test?.PerformaInvoiceGrossAmount,
                );

                // setallDiscountApply(false);
              }
            }),
          ),
          Promise.all(
            tc?.ListOfMachining?.map((m, mIndex) => {
              if (tc.IsSelected == true) {
                setallDiscountApply(true);
                setFieldValue(
                  `ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}].DiscountPercentage`,
                  applyAllDiscountPercentage,
                );
                calculateItemAmount(
                  `ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}]`,
                  m?.Qty,
                  m?.Rate,
                  applyAllDiscountPercentage,
                  m?.PerformaInvoiceIDEncrypted
                    ? m?.PerformaInvoiceIDEncrypted
                    : "",
                  0,
                );

                // setallDiscountApply(false);
              }
            }),
          )
        ),
      ),
    );

    setIsLoading(false);
    //setallDiscountApply(false);
  };

  const getTestRateByUnitID = async (
    itemFieldNameNode,
    unitid,
    testdeatilid,
    testmasterid,
    Qty,
    DiscountPercentage,
  ) => {
    let itemRate = 0;
    // let itemGrossAmount = 0;
    // let itemDiscountAmount = 0;
    // let itemNetAmount = 0;

    setIsLoading(true);
    await post(POST_GetTestRateByUnitID, {
      CustomerIDEncrypted: values?.CustomerIDEncrypted,
      InwardMaterialIDsEncrypted: Array.from(
        values?.InwardMaterialIDs,
        (x) => x.value,
      ).join(","),
      InwardMaterialTestDetailIDEncrypted: testdeatilid,
      TestMasterIDEncrypted: testmasterid,
      UnitID: unitid,
      InvoiceType: values?.InvoiceType,
    })
      .then((response) => {
        if (response?.IsSuccess) {
          setRateTypeName("");
          if (response?.ListOfTestRate?.length > 0) {
            itemRate = response?.ListOfTestRate[0].Rate;

            setFieldValue(`${itemFieldNameNode}.Rate`, itemRate);
            setFieldValue(
              `${itemFieldNameNode}.ListOfDefineMoreTestRate`,
              response?.ListOfTestRate[0].DefineMoreTestRateList,
            );

            // if (
            //   response?.ListOfTestRate[0]?.DefineMoreTestRateList.length > 0
            // ) {
            //   formikDefineMoreRates.setFieldValue(
            //     "MoreTestRatesList",
            //     response?.ListOfTestRate[0]?.DefineMoreTestRateList
            //   );
            // } else {
            //   formikDefineMoreRates.setFieldValue("MoreTestRatesList", "");
            // }

            setCalcGross(true);

            setTimeout(() => {
              calculateItemAmount(
                itemFieldNameNode,
                Qty,
                itemRate,
                DiscountPercentage,
                "",
                0,
              );
            }, 300);
          }
        }
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const [showDefineMoreRatesModal, setShowDefineMoreRatesModal] =
    useState(false);

  const getDefineMoreRatesDetail = async (
    tcIndex,
    testIndex,
    list,
    maintestRate,
  ) => {
    formikDefineMoreRates.resetForm();

    const totalTestRate = list.reduce(
      (sum, item) => sum + (parseFloat(item.TestRate) || 0),
      0,
    );

    formikDefineMoreRates.setFieldValue("TestListIndex", tcIndex);
    formikDefineMoreRates.setFieldValue("TestListIndexSub", testIndex);
    formikDefineMoreRates.setFieldValue("MoreTestRatesList", list);
    formikDefineMoreRates.setFieldValue(
      "MainTestRate",
      (maintestRate - totalTestRate).toFixed(2),
    );

    setShowDefineMoreRatesModal(true);
  };

  const validationSchemaDefineMoreRates = Yup.object().shape({});

  const formikDefineMoreRates = useFormik({
    validationSchema: validationSchemaDefineMoreRates,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitDefineMoreRates(values, formikHelpers),
    initialValues: {
      MoreTestRatesList: [],
      TestListIndex: -1,
      TestListIndexSub: -1,
      isDuplicate: false,
      MainTestRate: "",
    },
    validateOnBlur: false,
  });

  const {
    values: { MoreTestRatesList, MainTestRate },
  } = formikDefineMoreRates;

  const handleValidSubmitDefineMoreRates = async (values) => {
    setShowDefineMoreRatesModal(false);
  };

  return (
    <>
      <Row>
        <Col lg={6}>
          <label className="text-primary">Material Information</label>{" "}
          {values?.FormID !== 63 && (
            <React.Fragment>
              <input
                type="checkbox"
                className="form-check-input mt-0"
                id={"chkIsPrintLineItemRemarks"}
                name={"chkIsPrintLineItemRemarks"}
                checked={values?.IsPrintLineItemRemarks}
                onChange={(e) => {
                  setFieldValue("IsPrintLineItemRemarks", e?.target?.checked);
                }}
              />
              <label className="mb-1 ps-2">Print Line Item Remarks</label>{" "}
            </React.Fragment>
          )}
        </Col>

        {values?.FormID !== 63 && (
          <Col lg={6} style={{ textAlign: "right" }}>
            <span className="text-warning fs-12">
              [Note: Material Information will be reset on Inward No / TC No
              change.]
            </span>
          </Col>
        )}
        <Col lg={12}>
          <div className="table-responsive active-projects style-1 shorting mb-2">
            <div
              id="MaterialInfo-tbl_wrapper"
              className="dataTables_wrapper table-responsive no-footer"
            >
              <table
                id="MaterialInfo-tbl"
                className="table table-bordered no-footer mb-0"
              >
                <thead>
                  <tr>
                    <th width="1%"></th>
                    <th width="25%">Test Name</th>
                    {values?.FormID == 63 ? "" : <th width="22%">Remarks</th>}
                    <th width="7%" className="text-center">
                      Qty
                    </th>
                    <th width="10%">Unit</th>
                    <th width="8%" className="text-center">
                      Rate
                    </th>
                    <th width="10%" className="text-center p-1">
                      <div className="d-flex content-justify-between">
                        <div className="pe-1">Dis.(%)</div>
                        <Field
                          type="number"
                          placeholder="Apply Dis.(%)"
                          name="DiscountPercentageApplyToAll"
                          component={CustomInput}
                          noMarginBottom={true}
                          style={{
                            textAlign: "right",
                            lineHeight: 1,
                            minHeight: "1rem",
                            padding: "0rem 0.2rem",
                            height: "calc(1.1em + 0.3rem + 4px)",
                          }}
                          onChange={(e) => {
                            if (e?.target?.value <= 100) {
                              setFieldValue(
                                "DiscountPercentageApplyToAll",
                                e?.target?.value ?? "",
                              );
                              setTimeout(() => {
                                applyDiscountPercentageToAll(
                                  e?.target?.value ?? "",
                                );
                              }, 300);
                            }
                          }}
                        />
                      </div>
                    </th>
                    <th width="7%" className="text-center">
                      Discount
                    </th>
                    <th width="10%" className="pe-3">
                      Amount
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {values?.ListOfInwardMaterialsDetails?.length > 0 ? (
                    values?.ListOfInwardMaterialsDetails?.map((tc, tcIndex) => (
                      <>
                        <tr>
                          <td
                            colSpan={9}
                            style={{ textAlign: "left" }}
                            className="p-1"
                          >
                            {(values?.FormID == 52 || values?.FormID == 63) && (
                              <>
                                <input
                                  type="checkbox"
                                  className="form-check-input m-0"
                                  id={`chkTC${tcIndex}`}
                                  name={`chkTC${tcIndex}`}
                                  checked={tc.IsSelected}
                                  onChange={(e) => {
                                    handleChangeIsSelectedTC(
                                      e?.target?.checked,
                                      tcIndex,
                                    );
                                  }}
                                />
                                &nbsp;
                              </>
                            )}
                            <i className="fas fa-caret-right"></i>
                            <label className="mb-0 ms-2">{tc?.TCNo}</label>
                          </td>
                        </tr>
                        {tc?.ListOfTests?.map((test, testIndex) => (
                          <tr>
                            {values?.FormID == 52 || values?.FormID == 63 ? (
                              <td style={{ minWidth: "25px" }}></td>
                            ) : (
                              <td></td>
                            )}
                            <td
                              style={{ cursor: "pointer" }}
                              className="popupOverlay"
                            >
                              {test?.TestName}{" "}
                              {test?.ListOfDefineMoreTestRate?.length > 0 ? (
                                <OverlayTrigger
                                  trigger={["hover", "focus"]}
                                  responsive={true}
                                  overlay={
                                    <Tooltip className="toltip-popover">
                                      <strong className="p-1">
                                        Define More Test Rate
                                      </strong>
                                    </Tooltip>
                                  }
                                >
                                  <span
                                    onClick={() => {
                                      getDefineMoreRatesDetail(
                                        tcIndex,
                                        testIndex,
                                        test?.ListOfDefineMoreTestRate,
                                        test?.Rate,
                                      );
                                    }}
                                  >
                                    <i
                                      className="fa fa-info-circle"
                                      style={{
                                        cursor: "pointer",
                                        color: "#9698ab",
                                      }}
                                    ></i>
                                  </span>
                                </OverlayTrigger>
                              ) : (
                                ""
                              )}
                            </td>
                            {values?.FormID == 63 ? (
                              ""
                            ) : (
                              <td
                                className="p-1"
                                style={{
                                  minWidth: "200px",
                                }}
                              >
                                <Field
                                  name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].Remarks`}
                                  component={CustomInput}
                                  maxLength={500}
                                  noMarginBottom={true}
                                />
                              </td>
                            )}

                            <td
                              className="p-1"
                              style={{
                                minWidth: "60px",
                              }}
                            >
                              <Field
                                type="number"
                                name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].Qty`}
                                component={CustomInput}
                                numberTypeWithoutDot={true}
                                noMarginBottom={true}
                                style={{ textAlign: "right" }}
                                onChange={(e) => {
                                  if (tc.IsSelected == false) {
                                    handleChangeIsSelectedTC(true, tcIndex);
                                  }
                                  setFieldValue(
                                    `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].Qty`,
                                    e?.target?.value ?? "",
                                  );
                                  setTimeout(() => {
                                    calculateItemAmount(
                                      `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}]`,
                                      e?.target?.value ?? "",
                                      test?.Rate,
                                      test?.DiscountPercentage,
                                      test?.PerformaInvoiceIDEncrypted
                                        ? test?.PerformaInvoiceIDEncrypted
                                        : "",
                                      test?.PerformaInvoiceGrossAmount,
                                    );
                                  }, 300);
                                }}
                              />
                            </td>
                            <td
                              className="p-1"
                              style={{
                                minWidth: "120px",
                              }}
                            >
                              {values?.FormID == 63 ? (
                                test?.UnitName
                              ) : (
                                <Field
                                  name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].UnitID`}
                                  component={CustomSelect}
                                  options={values?.unitOptions}
                                  noMarginBottom={true}
                                  onChange={(e) => {
                                    setFieldValue(
                                      `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].UnitID`,
                                      e?.value ?? "",
                                    );
                                    // if (e?.value) {
                                    getTestRateByUnitID(
                                      `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}]`,
                                      e?.value ?? "0",
                                      test?.InwardMaterialTestDetailIDEncrypted,
                                      test?.TestMasterIDEncrypted,
                                      test?.Qty,
                                      test?.DiscountPercentage,
                                    );
                                    // }
                                  }}
                                  menuPosition={"fixed"}
                                />
                              )}
                            </td>
                            <td
                              className="p-1"
                              style={{
                                minWidth: "100px",
                              }}
                            >
                              <Field
                                type="number"
                                name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].Rate`}
                                component={CustomInput}
                                noMarginBottom={true}
                                style={{ textAlign: "right" }}
                                onChange={(e) => {
                                  if (tc.IsSelected == false) {
                                    handleChangeIsSelectedTC(true, tcIndex);
                                  }
                                  setFieldValue(
                                    `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].Rate`,
                                    e?.target?.value ?? "",
                                  );
                                  setTimeout(() => {
                                    calculateItemAmount(
                                      `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}]`,
                                      test?.Qty,
                                      e?.target?.value ?? "",
                                      test?.DiscountPercentage,
                                      test?.PerformaInvoiceIDEncrypted
                                        ? test?.PerformaInvoiceIDEncrypted
                                        : "",
                                      test?.PerformaInvoiceGrossAmount,
                                    );
                                  }, 300);
                                }}
                              />
                            </td>
                            <td
                              className="p-1"
                              style={{
                                minWidth: "100px",
                              }}
                            >
                              <Field
                                type="number"
                                name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].DiscountPercentage`}
                                component={CustomInput}
                                noMarginBottom={true}
                                style={{ textAlign: "right" }}
                                onChange={(e) => {
                                  if (e?.target?.value <= 100) {
                                    if (tc.IsSelected == false) {
                                      handleChangeIsSelectedTC(true, tcIndex);
                                    }
                                    setFieldValue(
                                      `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}].DiscountPercentage`,
                                      e?.target?.value ?? "",
                                    );
                                    setTimeout(() => {
                                      calculateItemAmount(
                                        `ListOfInwardMaterialsDetails[${tcIndex}].ListOfTests[${testIndex}]`,
                                        test?.Qty,
                                        test?.Rate,
                                        e?.target?.value ?? "",
                                        test?.PerformaInvoiceIDEncrypted
                                          ? test?.PerformaInvoiceIDEncrypted
                                          : "",
                                        test?.PerformaInvoiceGrossAmount,
                                      );
                                    }, 300);
                                  }
                                }}
                              />
                            </td>
                            <td
                              className="p-1 pe-3"
                              style={{
                                minWidth: "80px",
                                textAlign: "right",
                              }}
                            >
                              {test?.DiscountAmount}
                            </td>
                            <td
                              className="p-1 pe-3"
                              style={{
                                minWidth: "100px",
                              }}
                            >
                              {test?.NetAmount}
                            </td>
                          </tr>
                        ))}
                        {tc?.ListOfMachining?.map((m, mIndex) => (
                          <tr>
                            <td></td>
                            <td>
                              {m?.ProcessName}{" "}
                              <i className="fs-12">(Machining)</i>
                            </td>
                            {values?.FormID == 63 ? (
                              ""
                            ) : (
                              <td
                                className="p-1"
                                style={{
                                  minWidth: "200px",
                                }}
                              >
                                <Field
                                  name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}].Remarks`}
                                  component={CustomInput}
                                  maxLength={500}
                                  noMarginBottom={true}
                                />
                              </td>
                            )}
                            <td
                              className="p-1"
                              style={{
                                minWidth: "60px",
                              }}
                            >
                              <Field
                                type="number"
                                name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}].Qty`}
                                component={CustomInput}
                                numberTypeWithoutDot={true}
                                noMarginBottom={true}
                                style={{ textAlign: "right" }}
                                onChange={(e) => {
                                  if (tc.IsSelected == false) {
                                    handleChangeIsSelectedTC(true, tcIndex);
                                  }
                                  setFieldValue(
                                    `ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}].Qty`,
                                    e?.target?.value ?? "",
                                  );
                                  setTimeout(() => {
                                    calculateItemAmount(
                                      `ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}]`,
                                      e?.target?.value ?? "",
                                      m?.Rate,
                                      m?.DiscountPercentage,
                                      m?.PerformaInvoiceIDEncrypted
                                        ? m?.PerformaInvoiceIDEncrypted
                                        : "",
                                      0,
                                    );
                                  }, 300);
                                }}
                              />
                            </td>
                            <td
                              className="p-1"
                              style={{
                                minWidth: "120px",
                              }}
                            ></td>
                            <td
                              className="p-1"
                              style={{
                                minWidth: "100px",
                              }}
                            >
                              <Field
                                type="number"
                                name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}].Rate`}
                                component={CustomInput}
                                noMarginBottom={true}
                                style={{ textAlign: "right" }}
                                onChange={(e) => {
                                  if (tc.IsSelected == false) {
                                    handleChangeIsSelectedTC(true, tcIndex);
                                  }
                                  setFieldValue(
                                    `ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}].Rate`,
                                    e?.target?.value ?? "",
                                  );
                                  setTimeout(() => {
                                    calculateItemAmount(
                                      `ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}]`,
                                      m?.Qty,
                                      e?.target?.value ?? "",
                                      m?.DiscountPercentage,
                                      m?.PerformaInvoiceIDEncrypted
                                        ? m?.PerformaInvoiceIDEncrypted
                                        : "",
                                      0,
                                    );
                                  }, 300);
                                }}
                              />
                            </td>
                            <td
                              className="p-1"
                              style={{
                                minWidth: "100px",
                              }}
                            >
                              <Field
                                type="number"
                                name={`ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}].DiscountPercentage`}
                                component={CustomInput}
                                noMarginBottom={true}
                                style={{ textAlign: "right" }}
                                onChange={(e) => {
                                  if (e?.target?.value <= 100) {
                                    if (tc.IsSelected == false) {
                                      handleChangeIsSelectedTC(true, tcIndex);
                                    }
                                    setFieldValue(
                                      `ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}].DiscountPercentage`,
                                      e?.target?.value ?? "",
                                    );
                                    setTimeout(() => {
                                      calculateItemAmount(
                                        `ListOfInwardMaterialsDetails[${tcIndex}].ListOfMachining[${mIndex}]`,
                                        m?.Qty,
                                        m?.Rate,
                                        e?.target?.value ?? "",
                                        m?.PerformaInvoiceIDEncrypted
                                          ? m?.PerformaInvoiceIDEncrypted
                                          : "",
                                        0,
                                      );
                                    }, 300);
                                  }
                                }}
                              />
                            </td>
                            <td
                              className="p-1 pe-3"
                              style={{
                                minWidth: "80px",
                                textAlign: "right",
                              }}
                            >
                              {m?.DiscountAmount}
                            </td>
                            <td
                              className="p-1 pe-3"
                              style={{
                                minWidth: "100px",
                              }}
                            >
                              {m?.NetAmount}
                            </td>
                          </tr>
                        ))}
                      </>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={9} style={{ textAlign: "left" }}>
                        <div>{"No Record Found..."}</div>
                      </td>
                    </tr>
                  )}

                  <tr>
                    <td
                      colSpan={values?.FormID == 63 ? 4 : 5}
                      className="p-1 pe-2"
                      style={{ textAlign: "right" }}
                    >
                      <label className="mb-0">Gross Amount</label>
                    </td>
                    <td className="pe-2" style={{ textAlign: "right" }}>
                      {values?.GrossAmount}&nbsp;
                    </td>
                    <td
                      colSpan={2}
                      className="pe-3"
                      style={{ textAlign: "right" }}
                    >
                      {values?.ItemTotalDiscountAmount}
                    </td>
                    <td className="pe-3">{values?.ItemNetAmount}</td>
                  </tr>

                  <tr>
                    <td colSpan={values?.FormID == 63 ? 3 : 4} className="p-0">
                      <div className="table-responsive active-projects style-1 shorting">
                        <div
                          id="Expense-tbl_wrapper"
                          className="dataTables_wrapper table-responsive no-footer"
                        >
                          <table
                            id="Expense-tbl"
                            className="table table-bordered no-footer mb-0"
                          >
                            <thead>
                              <tr>
                                <th width="2%" className="newPara"></th>
                                <th width="38%" className="newPara">
                                  Expense
                                </th>
                                <th width="10%" className="newPara">
                                  Calc. Type
                                </th>
                                <th width="10%" className="newPara text-center">
                                  Qty
                                </th>
                                <th width="10%" className="newPara text-center">
                                  Rate
                                </th>
                                <th width="10%" className="newPara text-center">
                                  Discount(%)
                                </th>
                                <th width="10%" className="newPara text-center">
                                  Discount
                                </th>
                                <th width="10%" className="newPara pe-3">
                                  Amount
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {values?.ListOfExpense?.length > 0 ? (
                                values?.ListOfExpense?.map(
                                  (expense, eIndex) => (
                                    <tr key={eIndex}>
                                      <td className="p-1 ps-2 pe-2">
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id={`chkExpense${eIndex}`}
                                          name={`chkExpense${eIndex}`}
                                          checked={expense?.IsSelected}
                                          onChange={(e) => {
                                            setFieldValue(
                                              `ListOfExpense[${eIndex}].IsSelected`,
                                              e?.target?.checked,
                                            );

                                            //setCalcAdditional(true);
                                            setTimeout(() => {
                                              calculateExpenseAmount(
                                                `ListOfExpense[${eIndex}]`,
                                                expense?.CalcType,
                                                e?.target?.checked
                                                  ? expense?.Qty
                                                  : 0,
                                                expense?.ExpenseRate,
                                                expense?.DiscountPercentage,
                                                expense?.PerformaInvoiceIDEncrypted
                                                  ? expense?.PerformaInvoiceIDEncrypted
                                                  : "",
                                              );
                                            }, 300);
                                          }}
                                        />
                                      </td>
                                      <td className="p-1">
                                        {expense.ExpenseName}
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "100px",
                                        }}
                                      >
                                        {expense.CalcTypeName}
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "60px",
                                        }}
                                      >
                                        <Field
                                          type="number"
                                          name={`ListOfExpense[${eIndex}].Qty`}
                                          component={CustomInput}
                                          numberTypeWithoutDot={true}
                                          noMarginBottom={true}
                                          style={{ textAlign: "right" }}
                                          onChange={(e) => {
                                            setFieldValue(
                                              `ListOfExpense[${eIndex}].Qty`,
                                              e?.target?.value ?? "",
                                            );

                                            if (expense?.IsSelected == true) {
                                              setTimeout(() => {
                                                calculateExpenseAmount(
                                                  `ListOfExpense[${eIndex}]`,
                                                  expense?.CalcType,
                                                  e?.target?.value ?? "",
                                                  expense?.ExpenseRate,
                                                  expense?.DiscountPercentage,
                                                  expense?.PerformaInvoiceIDEncrypted
                                                    ? expense?.PerformaInvoiceIDEncrypted
                                                    : "",
                                                );
                                              }, 300);
                                            }
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "100px",
                                        }}
                                      >
                                        <Field
                                          type="number"
                                          name={`ListOfExpense[${eIndex}].ExpenseRate`}
                                          component={CustomInput}
                                          noMarginBottom={true}
                                          style={{ textAlign: "right" }}
                                          onChange={(e) => {
                                            if (
                                              expense?.CalcType == 1 ||
                                              (expense?.CalcType == 2 &&
                                                e?.target?.value <= 100)
                                            ) {
                                              setFieldValue(
                                                `ListOfExpense[${eIndex}].ExpenseRate`,
                                                e?.target?.value ?? "",
                                              );

                                              if (expense?.IsSelected == true) {
                                                setTimeout(() => {
                                                  calculateExpenseAmount(
                                                    `ListOfExpense[${eIndex}]`,
                                                    expense?.CalcType,
                                                    expense?.Qty,
                                                    e?.target?.value ?? "",
                                                    expense?.DiscountPercentage,
                                                    expense?.PerformaInvoiceIDEncrypted
                                                      ? expense?.PerformaInvoiceIDEncrypted
                                                      : "",
                                                  );
                                                }, 300);
                                              }
                                            }
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1"
                                        style={{
                                          minWidth: "100px",
                                        }}
                                      >
                                        <Field
                                          type="number"
                                          name={`ListOfExpense[${eIndex}].DiscountPercentage`}
                                          component={CustomInput}
                                          noMarginBottom={true}
                                          style={{ textAlign: "right" }}
                                          onChange={(e) => {
                                            if (e?.target?.value <= 100) {
                                              setFieldValue(
                                                `ListOfExpense[${eIndex}].DiscountPercentage`,
                                                e?.target?.value ?? "",
                                              );

                                              if (expense?.IsSelected == true) {
                                                setTimeout(() => {
                                                  calculateExpenseAmount(
                                                    `ListOfExpense[${eIndex}]`,
                                                    expense?.CalcType,
                                                    expense?.Qty,
                                                    expense?.ExpenseRate,
                                                    e?.target?.value ?? "",
                                                    expense?.PerformaInvoiceIDEncrypted
                                                      ? expense?.PerformaInvoiceIDEncrypted
                                                      : "",
                                                  );
                                                }, 300);
                                              }
                                            }
                                          }}
                                        />
                                      </td>
                                      <td
                                        className="p-1 pe-3"
                                        style={{
                                          minWidth: "80px",
                                          textAlign: "right",
                                        }}
                                      >
                                        {expense?.DiscountAmount}
                                      </td>
                                      <td
                                        className="p-1 pe-3"
                                        style={{
                                          minWidth: "100px",
                                        }}
                                      >
                                        {expense?.NetAmount}
                                      </td>
                                    </tr>
                                  ),
                                )
                              ) : (
                                <tr>
                                  <td colSpan={8} style={{ textAlign: "left" }}>
                                    <div>{"No Record Found..."}</div>
                                  </td>
                                </tr>
                              )}
                              <tr>
                                <td
                                  colSpan={4}
                                  className="p-1 pe-2"
                                  style={{ textAlign: "right" }}
                                >
                                  <label className="mb-0">Gross Amount</label>
                                </td>
                                <td
                                  className="pe-2"
                                  style={{ textAlign: "right" }}
                                >
                                  {values?.AdditionalAmount}&nbsp;
                                </td>
                                <td
                                  colSpan={2}
                                  className="pe-3"
                                  style={{ textAlign: "right" }}
                                >
                                  {values?.ExpenseTotalDiscountAmount}
                                </td>
                                <td className="pe-3">
                                  {values?.ExpenseNetAmount}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </td>
                    <td
                      colSpan={4}
                      style={{ verticalAlign: "top", textAlign: "right" }}
                    >
                      {/* <label className="mb-1" style={{ fontWeight: 400 }}>
                      Gross Amount
                    </label>
                    <br></br> */}
                      <label className="mb-1">Other Expense</label> <br></br>
                      <label className="mb-1">Total + Other Expense</label>
                      <br></br>
                      {values?.ListOfGSTPlans?.map((gst, gstIndex) => (
                        <>
                          <label className="mb-1" style={{ fontWeight: 400 }}>
                            {gst?.GSTCaption}
                          </label>
                          <br></br>
                        </>
                      ))}
                      {values?.RoundingOff &&
                        parseFloat(values?.RoundingOff) !== 0 && (
                          <>
                            <label className="mb-1" style={{ fontWeight: 400 }}>
                              Rounding Off
                            </label>
                            <br></br>
                          </>
                        )}
                      <label className="mb-1 p-1 pe-0">Net Amount</label>
                      <br></br>
                    </td>
                    <td
                      className="pe-3"
                      style={{ verticalAlign: "top", textAlign: "right" }}
                    >
                      {/* <label className="mb-1" style={{ fontWeight: 400 }}>
                      {values?.GrossAmount}
                    </label>
                    <br></br> */}
                      <label className="mb-1" style={{ fontWeight: 400 }}>
                        {values?.ExpenseNetAmount}
                      </label>
                      <br></br>
                      <label className="mb-1" style={{ fontWeight: 400 }}>
                        {values?.TotalGrossAmount}
                      </label>
                      <br></br>
                      {values?.ListOfGSTPlans?.map((gst, gstIndex) => (
                        <>
                          <label className="mb-1" style={{ fontWeight: 400 }}>
                            {gst?.GSTAmount}
                          </label>
                          <br></br>
                        </>
                      ))}
                      {values?.RoundingOff &&
                        parseFloat(values?.RoundingOff) !== 0 && (
                          <>
                            <label className="mb-1" style={{ fontWeight: 400 }}>
                              {values?.RoundingOff}
                            </label>
                            <br></br>
                          </>
                        )}
                      <label className="mb-1 bg-primary-light p-1 pe-0">
                        {values?.NetAmount}
                      </label>
                      <br></br>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </Col>
      </Row>
      <Modal
        className="fade"
        show={showDefineMoreRatesModal}
        onHide={setShowDefineMoreRatesModal}
        size="lg"
        backdrop="static"
      >
        <Spin
          size="large"
          spinning={isLoading}
          tip={"Loading..."}
          style={{ position: "fixed" }}
        >
          <FormikProvider value={formikDefineMoreRates}>
            <Form onSubmit={formikDefineMoreRates.handleSubmit}>
              <Modal.Header>
                <Modal.Title>Define More Rates</Modal.Title>
                <Button
                  type="button"
                  variant=""
                  className="btn-close"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                ></Button>
              </Modal.Header>
              <Modal.Body>
                {MainTestRate > 0 ? (
                  <>
                    <Row>
                      <Col lg={6}>
                        <div className="me-5">
                          <div className="d-flex">
                            <label>Standard Rate : {MainTestRate}</label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <hr className="mt-1 mb-2"></hr>
                  </>
                ) : (
                  ""
                )}
                <Row>
                  <Col lg={12}>
                    <div className="table-responsive active-projects style-1 shorting mb-2">
                      <div
                        id="DefineMoreRates-tbl_wrapper"
                        className="dataTables_wrapper no-footer"
                      >
                        <table
                          id="DefineMoreRates-tbl"
                          className="table dataTable no-footer mb-0"
                        >
                          <thead>
                            <tr>
                              <th width="5%">Sr No.</th>
                              <th width="28%">Rate Type</th>
                              <th width="23%">Unit</th>
                              <th width="12%">Min Value</th>
                              <th width="12%">Max Value</th>
                              <th width="20%" style={{ textAlign: "left" }}>
                                Rate
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {MoreTestRatesList?.length > 0 ? (
                              MoreTestRatesList?.map((itemTest, indxTest) => (
                                <tr key={indxTest}>
                                  <td
                                    style={{
                                      textAlign: "center",
                                    }}
                                    className="p-1"
                                  >
                                    {indxTest + 1}
                                  </td>

                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "150px",
                                    }}
                                  >
                                    {itemTest.RateTypeName}
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "150px",
                                    }}
                                  >
                                    {itemTest.UnitName}
                                    {itemTest.RateType == 1 ? (
                                      <>
                                        Per Element ({itemTest.TotalParameter})
                                      </>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "105px",
                                    }}
                                  >
                                    {itemTest.MinValue}
                                  </td>
                                  <td
                                    className="p-1"
                                    style={{
                                      minWidth: "105px",
                                    }}
                                  >
                                    {itemTest.MaxValue}
                                  </td>

                                  <td
                                    className="p-1"
                                    style={{
                                      textAlign: "left",
                                      minWidth: "150px",
                                    }}
                                  >
                                    {itemTest.TotalParameter > 0
                                      ? (
                                          parseFloat(itemTest.TestRate) /
                                          itemTest.TotalParameter
                                        ).toFixed(2)
                                      : parseFloat(itemTest.TestRate).toFixed(
                                          2,
                                        )}
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td
                                  colSpan={7}
                                  style={{
                                    textAlign: "left",
                                  }}
                                >
                                  <div>{"No Record Found..."}</div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="primary btn-sm"
                  onClick={() => setShowDefineMoreRatesModal(false)}
                >
                  OK
                </Button>
              </Modal.Footer>
            </Form>
          </FormikProvider>
        </Spin>
      </Modal>
    </>
  );
};

export default CommonMaterialInformation;
